import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
  useTheme,
} from '@mui/material';
import SearchableDropdown from '../shared/components/SearchableDropdown';

interface AddFromGroupModalProps {
  open: boolean;
  itemName: string; // plural
  groupName: string; // plural
  multi?: boolean
  groupOptions: SearchableDropdownOption[];
  onClose: () => void;
  onApply: (pathways: SearchableDropdownOption[]) => void;
}

const AddFromGroupModal: React.FC<AddFromGroupModalProps> = ({ open, itemName, groupName, multi=true, onClose, onApply, groupOptions }) => {
    const [groups, setGroups] = useState<SearchableDropdownOption[]>([]);

    useEffect(() => {
      setGroups([]);
    }, [open])

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>Add {itemName} From {groupName}</DialogTitle>
        <DialogContent>
        
        <div style={{'paddingTop': '10px'}}>
        <SearchableDropdown
            label={groupName}
            value={groups}
            multiple={multi}
            setValue={setGroups}
            options={groupOptions}
            placeholder={groupName}
        />
        </div>
            
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={() => {onApply(groups)}}>Apply</Button>
        </DialogActions>
        </Dialog>
    );
};

export default AddFromGroupModal;
